
import { defineComponent, ref } from 'vue';
import TheDetailPageHeader from '@/components/organisms/detailPage/TheDetailPageHeader.vue';
import TheDetailPageBody from '@/components/organisms/detailPage/TheDetailPageBody.vue';
import Heading from '@/components/atoms/Heading.vue';
import SignalText from '@/components/atoms/SignalText.vue';
import LinkButton from '@/components/organisms/utils/LinkButton.vue';

export default defineComponent({
  name: 'ApplyAvatarPosterTemplate',
  components: {
    TheDetailPageHeader,
    TheDetailPageBody,
    Heading,
    SignalText,
    LinkButton,
  },
  props: {
    i18n: {
      type: Object,
    },
  },
});
